<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered
          .column.is-12
            h1.title Comparación de Consumo de Grupos &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns.is-vcentered
          .column.is-1
            label.label Fecha
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='fechaJornada'
                  :config="config"
                  class="input"
                )
          .column.is-1
            a.button.is-black.is-rounded.is-small(@click="iniciarComponente")
              span.icon
                i.fas.fa-sync
        .columns.has-text-centered
          .column.is-5
            TbConsumos(:data="consumos")
          .columns.is-7
            div.is-full-center
              Grafica(:chart-data="dataGrafica" :options="options" :width='width' :height='heigth')
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBar from './layout/NavBar.vue'
  import TbConsumos from './componentes/TbConsumos.vue'
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import Grafica from '../dashboard/componentes/Grafica.vue'
  import Decimal from 'decimal.js'

  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import nominaciones_irgeServices from '@/services/sca/nominaciones/nominacionesIrge.js'

  export default {
    name: 'Consumos',
    components: { Loader, NavBar, flatPickr, TbConsumos, Grafica},
    data() {
      return {
        isLoading: true,
        fechaJornada: moment().format('YYYY-MM-DD'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        primerDia: '',
        ultimoDia: '',
        consumos: [],
        dataGrafica: {},
        width: 800,
        heigth: 400,
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 5
                }
              }
            ]
          },
          plugins: {
            title: {
              display: true,
              text: 'Nominaciones - Consumo',
            }
          }
        },
      }
    },
    watch: {
      fechaJornada() {
        this.primerDia = `${moment(this.fechaJornada).format('YYYY-MM-')}01`
        this.ultimoDia = moment(this.fechaJornada).endOf('month').format('YYYY-MM-DD')
        this.obtenerDataNominaciones()
      }
    },
    methods: {
      iniciarComponente() {
        this.primerDia = `${moment(this.fechaJornada).format('YYYY-MM-')}01`
        this.ultimoDia = moment(this.fechaJornada).endOf('month').format('YYYY-MM-DD')
        this.obtenerDataNominaciones()
      }, 

      obtenerDataNominaciones() {
        this.isLoading = true
        const year = moment(this.fechaJornada).format('YYYY')
        const month = moment(this.fechaJornada).format('MM')
        nominaciones_irgeServices.obtenerNominacionPeriodo(year, month, this.primerDia, this.fechaJornada)
          .then( data => {
            const consumos = data.map(this.convetirConsumos)
            this.consumos = this.ordenarFechas(consumos)
            this.arreglarDataGrafica(this.consumos)
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      ordenarFechas(consumos) {
        const consumosSorted = []
        const consumosOrdenados  = consumos.sort((a,b) => moment(a.fecha_nominacion).format('YYYYMMDD') - moment(b.fecha_nominacion).format('YYYYMMDD'))
        consumosOrdenados.map( c => {
          consumosSorted.push(c)
        })
        return consumosSorted
      },

      convetirConsumos(item) {
        const documentado = new Decimal(item.documentado)
        const nominacion = new Decimal(item.nominacion)
        const porcentaje = documentado.times(100).dividedBy(nominacion).toFixed(2)
        return {
          ...item,
          documentado: (item.documentado),
          nominacion: Number(item.nominacion),
          porcentaje
        }
      },

      arreglarDataGrafica(consumos) {
        // obtencion de fechas para grafica
        const fechas = []
        const grupos = []
        consumos.forEach(c => {
          fechas.push(c.fecha_nominacion)
          grupos.push(c.subgrupo)
        })
        const fechasUnicas = [...new Set(fechas)]
        const fechasGrafica = []
        fechasUnicas.forEach(f => {
          fechasGrafica.push(moment(f).format('DD'))
        })

        // Obtencion de grupos para grafica
        const gruposGrafica = [...new Set(grupos)]

        const datasets = []
        // Recorrer cada grupo
        gruposGrafica.forEach(g => {
            // obtener el dato de cada fecha - si es null que sea 0
          const dataFechas = []
          fechasUnicas.forEach(f => {
            const dataFind = this.consumos.find( c => c.subgrupo === g && c.fecha_nominacion === f)
            const dataGrupoFecha = dataFind ? dataFind.porcentaje : 0
            dataFechas.push(dataGrupoFecha)
          })
          datasets.push(dataFechas)
        })
        const colors = [
          { background: '#ff4d4d', borderColor: '#b83844' },
          { background: '#057d8d', borderColor: '#057d8d' },
          { background: '#74c545', borderColor: '#323237' },
          { background: '#f7ec54', borderColor: '#ff4d4d' },
          { background: '#53565A', borderColor: '#323237' },
        ]
        const datasetsGrafica = []
        datasets.forEach(( d, index) => {
          const myObj = {
            label: gruposGrafica[index],
            data: d,
            backgroundColor: colors[index].background,
            borderColor: colors[index].borderColor,
            borderWidth: 2,
          }
          datasetsGrafica.push(myObj)
        })
        this.dataGrafica = {
          labels: fechasGrafica,
          datasets: datasetsGrafica,
        }
      },

      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      backPage() {
        this.$router.back()
      },
      
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/cuartocontrol/Consumos.vue